// extracted by mini-css-extract-plugin
export default {"container":"Product_container__pzOI+","products":"Product_products__vsc9Z","menu":"Product_menu__fuv3L","list":"Product_list__YB4nW","product":"Product_product__RhKvN"};